import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { WoordenlijstPage } from "@/pages/woordenlijst";
import { glossaryJsonLd, validateGlossarySearch } from "@/lib/glossary-page";

export const Route = createFileRoute("/$lang/glossary/")({
  validateSearch: validateGlossarySearch,
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "en";
    const t = i18n.getFixedT(lang, "seo");
    return pageHead({
      lang,
      pathWithoutLang: "/woordenlijst",
      title: t("woordenlijst.title"),
      description: t("woordenlijst.description"),
      jsonLd: glossaryJsonLd(lang),
    });
  },
  component: WoordenlijstPage,
});
